/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { FancyIdJoin } from '../base/FancyIdJoin';
import { RoleList } from '../lists/RoleList';
import { LocationList } from '../lists/LocationList';
import { ProjectMemberList } from '../lists/ProjectMemberList';
import { PriorityList } from '../lists/PriorityList';

export function makeStandardTicketJoiners(
	roleList: RoleList,
	locationList: LocationList,
	projectMemberList: ProjectMemberList,
	priorityList: PriorityList
) {
	return [
		new FancyIdJoin('roleId', roleList),
		new FancyIdJoin('locationId', locationList),
		new FancyIdJoin('assignedProjectMemberId', projectMemberList),
		new FancyIdJoin('requestedByProjectMemberId', projectMemberList),
		new FancyIdJoin('responsibleProjectMemberId', projectMemberList),
		new FancyIdJoin('assignedProjectMemberRoleId', roleList),
		new FancyIdJoin('requestedByProjectMemberRoleId', roleList),
		new FancyIdJoin('responsibleProjectMemberRoleId', roleList),
		new FancyIdJoin('priorityId', priorityList),
	];
}
